<template>
    <div>

        <van-row >
            <van-divider />
            <van-col span="9" offset="1">
                <span >分类占比</span>
            </van-col>
            <van-col span="7" offset="7">
                <van-button :plain="isPlain" type="info" size="mini" round :color="payColor" @click="refreshType(false,12101)">支出</van-button>
                <van-button :plain="!isPlain" type="info" size="mini" round :color="incomeColor" @click="refreshType(true,12100)">收入</van-button>
            </van-col>
        </van-row>
        <van-row>
            <canvas :id="viewId" ></canvas>
            <fin-sort-detail v-if="!isPlain && isLoad" @getParData="getDetailData($event)" :year-date="searchDate" :sort="sort" :sort-name="sortName" :view-id="viewId+'SortDetailId'"></fin-sort-detail>
        </van-row>

    </div>

</template>

<script>
    import F2 from "@antv/f2/lib/index-all"
    import * as MyApi from '@/api/URLApiAddr.js'
    import * as FinUtil from '@/common/utils/finUtil.js'
    import FinSortDetail from "./FinSortDetail";
    export default {
        name: "FinYearSort",
        components: {
            FinSortDetail
        },
        props:{
            searchDate: {
                type: String,
                default: '',
            },
            rangeDate:{
                type: Object
            },
            viewId: {
                type: String,
                default: 'finYearSortPercent',
            }
        },
        data() {
            return {
                isPlain: false,
                payColor:'#E1B4AF',
                incomeColor:'#70cdd0',
                mainColor:'#E1B4AF',
                chart: undefined,
                sort: undefined,
                sortName: '',
                isLoad: false
            };
        },
        watch: {
            searchDate() {
                debugger
                this.isPlain = false
                this.drawData()
            },
            rangeDate() {
                debugger
                this.isPlain = false
                this.drawData()
            }
        },
        mounted(){
            this.drawData();
        },
        methods: {

            drawData(finType) {
                if(this.chart){
                    this.chart.destroy()
                }
                let params = {
                    year:this.searchDate,
                    finType:finType
                }

                let viewId = this.viewId;
                let thiz = this;
                this.$axios.post(MyApi.QRY_FIN_YEAR_SORT_PERCENT,params/*,options*/)
                    .then((response) =>  {
                        let code = response.code;
                        let data = response.data;
                        debugger
                        if(code == 200){
                            //计算明细占比
                            if(!this.isPlain){
                                this.setParData(this.isPlain,data[0]);
                            }
                            //计算占比
                            let map = FinUtil.calculatePercent(data,'money','type');
                            let viewHeight = (window.innerWidth*3/4) + 50
                            const chart = new F2.Chart({
                                id: viewId,
                                width:window.innerWidth,
                                height:viewHeight,
                                pixelRatio: window.devicePixelRatio,
                                padding: [40, 'auto', 'auto', 'auto']
                            });
                            chart.source(data);
                            chart.coord('polar', {
                                transposed: true,
                                radius: 0.9,
                                innerRadius: 0.5
                            });
                            chart.axis(false);
                            chart.legend('type', {
                                position: 'bottom',
                                align: 'center',
                                itemFormatter: function itemFormatter(val) {
                                    return val + '  ' + map[val]+'%';
                                }
                            });
                            chart.tooltip(false);
                            chart.guide()
                                .html({
                                    position: [ '50%', '50%' ],
                                    html: '<div style="text-align: center;width:150px;height: 50px;">\n      <p style="font-size: 12px;color: #999;margin: 0" id="title"></p>\n      <p style="font-size: 18px;color: #343434;margin: 0;font-weight: bold;" id="money"></p>\n      </div>'
                                });
                            chart.interval()
                                .position('const*money')
                                .adjust('stack')
                                .color('type', [ '#E1B4AF','#FF7F00','#836FFF','#1890FF', '#13C2C2', '#2FC25B', '#FACC14' ]);
                            chart.pieLabel({
                                sidePadding: 30,
                                activeShape: true,
                                label1: function label1(data) {
                                    return {
                                        text: '￥' + data.money,
                                        fill: '#343434',
                                        fontWeight: 'bold'
                                    };
                                },
                                label2: function label2(data) {
                                    return {
                                        text: data.type,
                                        fill: '#999'
                                    };
                                },
                                onClick: function onClick(ev) {
                                    const data = ev.data;
                                    if (data) {
                                        debugger;
                                        thiz.setParData(thiz.isPlain,data,data.sort)
                                        // let res = {}
                                        // //true为收入，false为支出
                                        // if(thiz.isPlain){
                                        //     res["sortDetail"] = data.sort
                                        //     res["finType"] = 12100
                                        // }else{
                                        //     res["sort"] = data.sort
                                        //     res["finType"] = 12101
                                        // }
                                        // thiz.$emit('getParData', res)

                                        // $('#title').text(data.type);
                                        // $('#money').text(data.money);
                                    }
                                },
                                triggerOn: 'click'
                            });
                            this.chart = chart
                            chart.render();
                        }

                    })
                    .catch((err) => {
                        debugger
                        console.log(err)
                        this.$toast.fail("请求异常,请稍后再试"+err);
                    })

            },
            refreshType(flag,finType) {
                if(flag){
                    this.mainColor = this.incomeColor
                }else{
                    this.mainColor = this.payColor
                }
                this.isPlain = flag
                this.drawData(finType)


            },
            setParData(finTypeFlag,data,sortDetail) {
                let res = {}
                //true为收入，false为支出
                if(finTypeFlag){
                    res["sortDetail"] = sortDetail
                    res["finType"] = 12100
                }else{
                    this.isLoad = true
                    res["sort"] = data.sort
                    res["finType"] = 12101
                    this.sort = data.sort
                    this.sortName = data.type
                }

                this.$emit('getParData', res)

            },
            getDetailData(data){
                if(!this.isPlain){
                    if(data.detail){
                        let res = {}
                        res["detail"] = data.detail
                        this.$emit('getParData', res)
                    }
                }
            }
        }
    }
</script>

<style scoped>

</style>
